import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewMotivoBajaCabeza = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'motivo_baja_cabeza',
        name: 'Motivo de Egreso',
        component: ViewMotivoBajaCabeza,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
